import styled from 'styled-components';

import { ThemeProp } from '../../../theme/Themes';
import Button, { ButtonProps } from '..';

const SecondaryButton = styled(Button)`
  color: ${(props: ThemeProp & ButtonProps) => props.$color || props.theme.colors.neutrals.white};
  border: 1px solid ${(props: ThemeProp & ButtonProps) => props.theme.colors.neutrals.white};
  background: transparent;

  svg {
    stroke: ${({ theme }) => theme.colors.neutrals.white};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutrals.white};
    color: ${({ theme }) => theme.colors.neutrals.black};
    svg {
      stroke: ${({ theme }) => theme.colors.neutrals.black};
      path {
        fill: ${({ theme }) => theme.colors.neutrals.black};
      }
    }
  }

  &:disabled {
    border: none;
  }
`;

export default SecondaryButton;
